






































import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import { showErrors, showNotification } from '@/utils/snack'
import { SnackType } from '@/interfaces/snack'
import AppDialog from '@/components/AppDialog.vue'
import AppSteps from '@/components/AppSteps.vue'
import InsuredFormLife from '@/modules/Insured/components/forms/InsuredFormLife.vue'
import InsuredFormInfo from '@/modules/Insured/components/forms/InsuredFormInfo.vue'
import InsuredFormContact from '@/modules/Insured/components/forms/InsuredFormContact.vue'
import InsuredFormDriver from '@/modules/Insured/components/forms/InsuredFormDriver.vue'
import InsuredFormEmployment from '@/modules/Insured/components/forms/InsuredFormEmployment.vue'
import { Insured } from '@/modules/Insured/interfaces/insured'
import { newInsured, editInsured } from '@/modules/Insured/gql/insured.gql'
import { Case } from '@/modules/Case/interfaces/case'
import { Policy } from '@/modules/Policy/interfaces/policy'
import { Quote } from '@/modules/Quote/interfaces/quote'
import { IInsuredInfoInput, IInsuredContactInput, IInsuredLifeInput, IInsuredEmploymentInput, IInsuredDriverInput } from '@/modules/Insured/interfaces/insured-form'
import { relationKeys, genderKeys, includedKeys, educationKeys, licenseKeys, maritalKeys, duiKeys, srKeys, healthKeys } from '@/modules/Insured/helpers/insured'
import delNonNumCode from '@/utils/delNonNumCode'

@Component({
  components: {
    InsuredFormLife,
    InsuredFormInfo,
    AppDialog,
    InsuredFormDriver,
    InsuredFormContact,
    InsuredFormEmployment,
    AppSteps
  }
})
export default class InsuredForm extends Vue {
  @Prop(Boolean) value!: boolean
  @Prop(Number) readonly step!: number
  @Prop(String) readonly title!: string
  @Prop({ type: Object as () => Insured }) readonly insured!: Insured
  @Prop({ type: Object as () => Policy }) readonly policy!: Policy
  @Prop({ type: Object as () => Quote }) readonly quote!: Quote
  @Prop({ type: Object as () => Case }) readonly caseInfo!: Case

  showDialog = false
  loading = false

  stepIndex = 0
  steps = [
    ['Insured Info', 770, 471],
    ['Contact Info', 770, 511],
    ['Driver Info', 770, 691],
    ['Employment Info', 770, 441],
    ['Life/Health Info', 770, 851]
  ]

  infoInput: IInsuredInfoInput = {
    name: '',
    relationShipIdx: -1,
    genderIdx: -1,
    includedOrExcludedIdx: -1,
    usCitizen: false,
    notes: ''
  }

  contactInput: IInsuredContactInput = {
    firstName: '',
    middleName: '',
    lastName: '',
    educationLevelIdx: -1,
    socSec: '',
    dateOfBirth: '',
    maritalStatusIdx: -1
  }

  driverInput: IInsuredDriverInput = {
    driversLicenseNumber: '',
    licenseStatusIdx: -1,
    accidentsOrViolations: '',
    licenseState: '',
    matureDriver: false,
    studentFarAway: false,
    goodStudent: false,
    goodDriver: false,
    driverTraining: false,
    defensiveDriverCourseDate: '',
    dateLicensed: '',
    duiIdx: -1,
    srOrFrIdx: -1
  }

  employmentInput: IInsuredEmploymentInput = {
    currentEmployerInformation: '',
    previousEmployerInformation: '',
    employerPhone: '',
    occupationClassCode: '',
    title: '',
    occupationYears: ''
  }

  lifeInput: IInsuredLifeInput = {
    expectedAnnualIncome: '',
    additionalIncome: '',
    aagIncome: '',
    employerHealthInsuranceIdx: -1,
    employeeOHIAmount: '',
    spouseEOInsuranceIdx: -1,
    spouseEOHIAmount: '',
    preExistingConditions: '',
    medications: '',
    weight: '',
    height: '',
    healthClassIdx: -1,
    ddcExpiredDate: '',
    tobaccoUser: false,
    receivesMedicareOrMedicaid: false,
    receiveSocialSecurityBenefits: false,
    needsInsurance: false
  }

  get stepItems () {
    return this.steps.map(st => st[0])
  }

  get hightLightTitle () {
    return ''
  }

  get showBackBtn () {
    return this.stepIndex > 0
  }

  get confirmText () {
    return this.stepIndex < this.steps.length - 1
      ? 'Next'
      : this.insured
        ? 'Save'
        : 'Create'
  }

  get confirmAheadText () {
    return this.insured ? 'Save' : 'Create'
  }

  get canPost () {
    return this.stepIndex < this.steps.length
  }

  @Watch('value')
  onValueChanged (val: boolean) {
    this.showDialog = val
    if (val) {
      this.resetStep()
      this.initInput()
    }
  }

  resetStep () {
    this.stepIndex = this.step
  }

  initInput () {
    if (this.insured) {
      const {
        name, relationShip, gender, includedOrExcluded, usCitizen, notes,
        firstName, middleName, lastName, educationLevel, socSec, dateOfBirth, maritalStatus,
        driversLicenseNumber, licenseStatus, accidentsOrViolations, licenseState, matureDriver, studentFarAway, goodStudent, goodDriver, driverTraining, defensiveDriverCourseDate, dateLicensed, dui, srOrFr,
        currentEmployerInformation, previousEmployerInformation, employerPhone,
        countryCode, countryCallingCode, extensionNumber, occupationClassCode, title, occupationYears,
        expectedAnnualIncome, additionalIncome, aagIncome, employerHealthInsurance, employeeOHIAmount, spouseEOInsurance, spouseEOHIAmount, preExistingConditions, medications, weight, height, healthClass, ddcExpiredDate, tobaccoUser, receivesMedicareOrMedicaid, receiveSocialSecurityBenefits, needsInsurance
      } = this.insured

      this.infoInput = {
        name,
        relationShipIdx: relationKeys.findIndex(key => key === relationShip),
        genderIdx: genderKeys.findIndex(key => key === gender),
        includedOrExcludedIdx: includedKeys.findIndex(key => key === includedOrExcluded),
        usCitizen,
        notes
      }

      this.contactInput = {
        firstName,
        middleName,
        lastName,
        educationLevelIdx: educationKeys.findIndex(key => key === educationLevel),
        socSec,
        dateOfBirth,
        maritalStatusIdx: maritalKeys.findIndex(key => key === maritalStatus)
      }

      this.driverInput = {
        driversLicenseNumber,
        licenseStatusIdx: licenseKeys.findIndex(key => key === licenseStatus),
        accidentsOrViolations,
        licenseState,
        matureDriver,
        studentFarAway,
        goodStudent,
        goodDriver,
        driverTraining,
        defensiveDriverCourseDate,
        dateLicensed,
        duiIdx: duiKeys.findIndex(key => key === dui),
        srOrFrIdx: srKeys.findIndex(key => key === srOrFr)
      }

      this.employmentInput = {
        currentEmployerInformation,
        previousEmployerInformation,
        employerPhone: (countryCode || '') + ',' + (employerPhone || '') + ',' + (extensionNumber || '') + ',' + (countryCallingCode || ''),
        occupationClassCode,
        title,
        occupationYears
      }

      this.lifeInput = {
        expectedAnnualIncome,
        additionalIncome,
        aagIncome,
        employerHealthInsuranceIdx: duiKeys.findIndex(key => key === employerHealthInsurance),
        employeeOHIAmount,
        spouseEOInsuranceIdx: duiKeys.findIndex(key => key === spouseEOInsurance),
        spouseEOHIAmount,
        preExistingConditions,
        medications,
        weight,
        height,
        healthClassIdx: healthKeys.findIndex(key => key === healthClass),
        ddcExpiredDate,
        tobaccoUser,
        receivesMedicareOrMedicaid,
        receiveSocialSecurityBenefits,
        needsInsurance
      }
    } else {
      this.clearForm()
    }
  }

  handleStepClick (index: number) {
    if (!this.insured) {
      return
    }

    const pass = this.handleValidate()
    if (!pass) {
      return
    }

    this.stepIndex = index
  }

  handleValidate () {
    const { stepIndex, steps } = this
    const refName = steps[stepIndex][0] as string
    return (this.$refs[refName] as Vue & {
      validate: () => null | { [key: string]: number | string }
    }).validate()
  }

  handleConfirm (event: Event, finishAhead = false) {
    const pass = this.handleValidate()
    if (!pass) {
      return
    }

    if (this.stepIndex === this.steps.length - 1 || finishAhead) {
      this.loading = true
      if (this.insured) {
        this.handleUpdate()
      } else {
        this.handleCreate()
      }
    } else {
      this.stepIndex += 1
    }
  }

  handleBack () {
    this.stepIndex -= 1
  }

  async handleCreate () {
    const {
      infoInput: {
        name,
        relationShipIdx,
        genderIdx,
        includedOrExcludedIdx,
        usCitizen,
        notes
      },
      contactInput: {
        firstName,
        middleName,
        lastName,
        educationLevelIdx,
        socSec,
        dateOfBirth,
        maritalStatusIdx
      },
      driverInput: {
        driversLicenseNumber,
        licenseStatusIdx,
        accidentsOrViolations,
        licenseState,
        matureDriver,
        studentFarAway,
        goodStudent,
        goodDriver,
        driverTraining,
        defensiveDriverCourseDate,
        dateLicensed,
        duiIdx,
        srOrFrIdx
      },
      employmentInput: {
        currentEmployerInformation,
        previousEmployerInformation,
        employerPhone,
        occupationClassCode,
        title,
        occupationYears
      },

      lifeInput: {
        expectedAnnualIncome,
        additionalIncome,
        aagIncome,
        employerHealthInsuranceIdx,
        employeeOHIAmount,
        spouseEOInsuranceIdx,
        spouseEOHIAmount,
        preExistingConditions,
        medications,
        weight,
        height,
        healthClassIdx,
        ddcExpiredDate,
        tobaccoUser,
        receivesMedicareOrMedicaid,
        receiveSocialSecurityBenefits,
        needsInsurance
      }
    } = this

    const phoneArr = employerPhone.split(',')

    try {
      const res = await this.$apollo.mutate({
        mutation: newInsured,
        variables: {
          insuredInput: {
            name,
            relationShip: relationKeys[relationShipIdx] || null,
            gender: genderKeys[genderIdx] || null,
            includedOrExcluded: includedKeys[includedOrExcludedIdx] || null,
            usCitizen,
            firstName,
            middleName,
            lastName,
            educationLevel: educationKeys[educationLevelIdx] || null,
            socSec,
            dateOfBirth,
            maritalStatus: maritalKeys[maritalStatusIdx] || null,
            driversLicenseNumber,
            licenseStatus: licenseKeys[licenseStatusIdx] || null,
            accidentsOrViolations,
            licenseState,
            matureDriver,
            studentFarAway,
            goodStudent,
            goodDriver,
            driverTraining,
            defensiveDriverCourseDate,
            dateLicensed,
            dui: duiKeys[duiIdx] || null,
            srOrFr: srKeys[srOrFrIdx] || null,
            currentEmployerInformation,
            previousEmployerInformation,
            employerPhone: delNonNumCode(phoneArr[1] || ''),
            extensionNumber: phoneArr[2] || '',
            countryCode: phoneArr[0] || '',
            countryCallingCode: phoneArr[3] || '',
            occupationClassCode,
            title,
            occupationYears,
            expectedAnnualIncome,
            additionalIncome,
            aagIncome,
            employerHealthInsurance: duiKeys[employerHealthInsuranceIdx] || null,
            employeeOHIAmount,
            spouseEOInsurance: duiKeys[spouseEOInsuranceIdx] || null,
            spouseEOHIAmount,
            preExistingConditions,
            medications,
            weight,
            height,
            healthClass: healthKeys[healthClassIdx] || null,
            ddcExpiredDate,
            tobaccoUser,
            receivesMedicareOrMedicaid,
            receiveSocialSecurityBenefits,
            needsInsurance,
            notes,
            quoteId: this.quote ? Number(this.quote.id) : null,
            policyId: this.policy ? Number(this.policy.id) : null,
            caseId: this.caseInfo ? Number(this.caseInfo.id) : null
          }
        }
      })
      this.clearForm()
      this.onSuccess('Create the new insured successfully')
    } catch (e) {
      this.loading = false
      showErrors(e.graphQLErrors)
    }
  }

  async handleUpdate () {
    const {
      infoInput: {
        name,
        relationShipIdx,
        genderIdx,
        includedOrExcludedIdx,
        usCitizen,
        notes
      },
      contactInput: {
        firstName,
        middleName,
        lastName,
        educationLevelIdx,
        socSec,
        dateOfBirth,
        maritalStatusIdx
      },
      driverInput: {
        driversLicenseNumber,
        licenseStatusIdx,
        accidentsOrViolations,
        licenseState,
        matureDriver,
        studentFarAway,
        goodStudent,
        goodDriver,
        driverTraining,
        defensiveDriverCourseDate,
        dateLicensed,
        duiIdx,
        srOrFrIdx
      },
      employmentInput: {
        currentEmployerInformation,
        previousEmployerInformation,
        employerPhone,
        occupationClassCode,
        title,
        occupationYears
      },

      lifeInput: {
        expectedAnnualIncome,
        additionalIncome,
        aagIncome,
        employerHealthInsuranceIdx,
        employeeOHIAmount,
        spouseEOInsuranceIdx,
        spouseEOHIAmount,
        preExistingConditions,
        medications,
        weight,
        height,
        healthClassIdx,
        ddcExpiredDate,
        tobaccoUser,
        receivesMedicareOrMedicaid,
        receiveSocialSecurityBenefits,
        needsInsurance
      }
    } = this

    const phoneArr = employerPhone.split(',')

    try {
      const res = await this.$apollo.mutate({
        mutation: editInsured,
        variables: {
          insuredId: +this.insured.id,
          insuredInput: {
            name,
            relationShip: relationKeys[relationShipIdx] || null,
            gender: genderKeys[genderIdx] || null,
            includedOrExcluded: includedKeys[includedOrExcludedIdx] || null,
            usCitizen,
            firstName,
            middleName,
            lastName,
            educationLevel: educationKeys[educationLevelIdx] || null,
            socSec,
            dateOfBirth,
            maritalStatus: maritalKeys[maritalStatusIdx] || null,
            driversLicenseNumber,
            licenseStatus: licenseKeys[licenseStatusIdx] || null,
            accidentsOrViolations,
            licenseState,
            matureDriver,
            studentFarAway,
            goodStudent,
            goodDriver,
            driverTraining,
            defensiveDriverCourseDate,
            dateLicensed,
            dui: duiKeys[duiIdx] || null,
            srOrFr: srKeys[srOrFrIdx] || null,
            currentEmployerInformation,
            previousEmployerInformation,
            employerPhone: delNonNumCode(phoneArr[1] || ''),
            extensionNumber: phoneArr[2] || '',
            countryCode: phoneArr[0] || '',
            countryCallingCode: phoneArr[3] || '',
            occupationClassCode,
            title,
            occupationYears,
            expectedAnnualIncome,
            additionalIncome,
            aagIncome,
            employerHealthInsurance: duiKeys[employerHealthInsuranceIdx] || null,
            employeeOHIAmount,
            spouseEOInsurance: duiKeys[spouseEOInsuranceIdx] || null,
            spouseEOHIAmount,
            preExistingConditions,
            medications,
            weight,
            height,
            healthClass: healthKeys[healthClassIdx] || null,
            ddcExpiredDate,
            tobaccoUser,
            receivesMedicareOrMedicaid,
            receiveSocialSecurityBenefits,
            needsInsurance,
            notes,
            quoteId: this.quote ? Number(this.quote.id) : null,
            policyId: this.policy ? Number(this.policy.id) : null,
            caseId: this.caseInfo ? Number(this.caseInfo.id) : null
          }
        }
      })
      this.clearForm()
      this.onSuccess('Update insured successfully')
    } catch (e) {
      this.loading = false
      showErrors(e.graphQLErrors)
    }
  }

  clearForm () {
    this.loading = false
    this.infoInput = {
      name: '',
      relationShipIdx: -1,
      genderIdx: -1,
      includedOrExcludedIdx: -1,
      usCitizen: false,
      notes: ''
    }

    this.contactInput = {
      firstName: '',
      middleName: '',
      lastName: '',
      educationLevelIdx: -1,
      socSec: '',
      dateOfBirth: '',
      maritalStatusIdx: -1
    }

    this.driverInput = {
      driversLicenseNumber: '',
      licenseStatusIdx: -1,
      accidentsOrViolations: '',
      licenseState: '',
      matureDriver: false,
      studentFarAway: false,
      goodStudent: false,
      goodDriver: false,
      driverTraining: false,
      defensiveDriverCourseDate: '',
      dateLicensed: '',
      duiIdx: -1,
      srOrFrIdx: -1
    }

    this.employmentInput = {
      currentEmployerInformation: '',
      previousEmployerInformation: '',
      employerPhone: '',
      occupationClassCode: '',
      title: '',
      occupationYears: ''
    }

    this.lifeInput = {
      expectedAnnualIncome: '',
      additionalIncome: '',
      aagIncome: '',
      employerHealthInsuranceIdx: -1,
      employeeOHIAmount: '',
      spouseEOInsuranceIdx: -1,
      spouseEOHIAmount: '',
      preExistingConditions: '',
      medications: '',
      weight: '',
      height: '',
      healthClassIdx: -1,
      ddcExpiredDate: '',
      tobaccoUser: false,
      receivesMedicareOrMedicaid: false,
      receiveSocialSecurityBenefits: false,
      needsInsurance: false
    }
  }

  @Emit('cancel')
  handleCancel () {
    this.$emit('input', false)
    this.clearForm()
  }

  @Emit('success')
  onSuccess (msg = '') {
    this.$emit('input', false)
    this.resetStep()
    if (msg) {
      showNotification({
        msg,
        type: SnackType.Success
      })
    }
  }
}
